import { cloneDeep } from "lodash";
import React, { ChangeEvent, useRef, useState } from "react";
import { useAlert } from "react-alert";
import ReactModal from "react-modal";
import { ErrorRoundedFilledIcon } from "../components/icons/themes/windows10";
import { EditableProject } from "../reducers/environments";

const modalStyles = {
    content: {
        zIndex: 10050,
        minHeight: `100px`,
        width: 600,
        top: "auto",
        bottom: "auto",
        right: "auto",
        left: "auto",
        position: "static" as "static",
        display: "flex",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};
export type ModalState = {
    title: string;
    placeholder: string;
    project: EditableProject;
    closeOnOverlay: boolean;
    addingNewProject?: boolean;
    error?: string;
    addingNewEnvironment?: boolean;
    onClose?: () => void;
    onSave: (updatedProject: EditableProject) => void;
};


export const AdvancedConfigProjectModal: React.FC<ModalState> = ({
    addingNewEnvironment = false,
    addingNewProject = false,
    project,
    placeholder,
    onSave,
    title,
    onClose,
    closeOnOverlay,
    error,
}) => {
    const alert = useAlert();
    const [newProjectState, setNewProjectState] = useState(cloneDeep(project));
    const [initialDocumentLoadCode, setInitialDocumentLoadCode] = useState((project.codeEval && project.codeEval.onPageLoad) ? project.codeEval.onPageLoad : '');
    const [pageChangeCode, setPageChangeCode] = useState((project.codeEval && project.codeEval.onPageChange) ? project.codeEval.onPageChange : '');

    const onConfirm = () => {
        newProjectState.codeEval = {
            'onPageLoad': initialDocumentLoadCode,
            'onPageChange': pageChangeCode,
        }
        onSave(newProjectState);
    };

    // @ts-ignore
    const handleInitialDocumentLoadedChange = (e: ChangeEvent<HTMLTextAreaElement>) => setInitialDocumentLoadCode(e.target.value)

    // @ts-ignore
    const handlePageChangeCode = (e: ChangeEvent<HTMLTextAreaElement>) => setPageChangeCode(e.target.value)

    return (<ReactModal
        isOpen={true}
        onRequestClose={closeOnOverlay ? onClose : () => {}}
        style={modalStyles}
        contentLabel={title}
    >

        <div className="flex flex-col justify-between w-full">
            <div className="pb-4 mb-4 border-b">
                <h2 className="text-xl text-gray-900">{title}</h2>
                <h4 className="text-md uppercase text-gray-500 font-bold">Project: {project.name}</h4>
            </div>

            <div className="text-lg text-gray-700">Tag Manager:</div>
            <p className="text-xs text-gray-700">Our tag manager feature allows you to inject code directly on your website.</p>

            <div className="text-sm font-bold text-gray-900 mt-2">On Initial Document Load:</div>
            <textarea className='border-0 bg-gray-100 px-2 py-3 text-gray-900 mb-4 font-mono text-xs' style={{minHeight: 120}} onChange={handleInitialDocumentLoadedChange} value={initialDocumentLoadCode} placeholder="Javascript code..."/>

            <div className="text-sm font-bold text-gray-900">On Page Change:</div>
            <textarea className='border-0 bg-gray-100 px-2 py-3 text-gray-900 mb-4 font-mono text-xs' style={{minHeight: 120}} onChange={handlePageChangeCode} value={pageChangeCode} placeholder="Javascript code..."/>

            <div className="mt-8">
                {/* ERROR MESSAGE */}
                {error && (
                    <div className="px-3 mb-3 bg-red-500 text-white py-2 font-bold text-lg flex items-center rounded">
                        <ErrorRoundedFilledIcon className="fill-white mr-2"/>
                        {error}
                    </div>
                )}

                <div className="flex space-between">
                    <button className="w-full rounded btn py-2 bg-red-200 text-red-900 hover:bg-red-300 text-center "
                            onClick={onClose}>
                        Cancel
                    </button>
                    <div className="w-4 flex-shrink-0 flex-grow-0"/>
                    <button
                        className="rounded w-full btn py-2 text-center bg-purple-200 text-purple-900 hover:bg-purple-300"
                        onClick={onConfirm}>Save
                    </button>
                </div>
            </div>
        </div>
    </ReactModal>);
};